"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SonarObjectTypeId = exports.SonarObjectType = void 0;
var SonarObjectType;
(function (SonarObjectType) {
    SonarObjectType["PardotAutomation"] = "pardotAutomation";
    SonarObjectType["PardotEmail"] = "pardotEmail";
    SonarObjectType["PardotEmailTemplate"] = "pardotEmailTemplate";
    SonarObjectType["PardotEntity"] = "pardotEntity";
    SonarObjectType["PardotField"] = "pardotField";
    SonarObjectType["PardotForm"] = "pardotForm";
    SonarObjectType["PardotLandingPage"] = "pardotLandingPage";
    SonarObjectType["PardotList"] = "pardotList";
    SonarObjectType["PardotPageAction"] = "pardotPageAction";
    SonarObjectType["PardotProfile"] = "pardotProfile";
    SonarObjectType["SalesforceApexClass"] = "sfdcApexClass";
    SonarObjectType["SalesforceApexTrigger"] = "sfdcApexTrigger";
    SonarObjectType["SalesforceEmailTemplate"] = "sfdcEmailTemplate";
    SonarObjectType["SalesforceEntity"] = "sfdcEntity";
    SonarObjectType["SalesforceField"] = "sfdcField";
    SonarObjectType["SalesforceFlow"] = "sfdcFlow";
    SonarObjectType["SalesforcePageLayout"] = "sfdcPageLayout";
    SonarObjectType["SalesforcePicklistValue"] = "sfdcPicklistValue";
    SonarObjectType["SalesforceProcessBuilder"] = "sfdcProcessBuilder";
    SonarObjectType["SalesforceProfile"] = "sfdcProfile";
    SonarObjectType["SalesforceReport"] = "sfdcReport";
    SonarObjectType["SalesforceWorkflowRule"] = "sfdcWorkflowRule";
    SonarObjectType["SalesforceWorkflowAlert"] = "sfdcWorkflowAlert";
    SonarObjectType["SalesforceFieldUpdate"] = "sfdcFieldUpdate";
    SonarObjectType["SalesforceValidationRule"] = "sfdcValidationRule";
    SonarObjectType["SonarTag"] = "sonarTag";
})(SonarObjectType || (exports.SonarObjectType = SonarObjectType = {}));
var SonarObjectTypeId;
(function (SonarObjectTypeId) {
    SonarObjectTypeId[SonarObjectTypeId["SonarTag"] = 0] = "SonarTag";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceEntity"] = 1] = "SalesforceEntity";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceField"] = 2] = "SalesforceField";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceFlow"] = 3] = "SalesforceFlow";
    SonarObjectTypeId[SonarObjectTypeId["SalesforcePicklistValue"] = 4] = "SalesforcePicklistValue";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceProcessBuilder"] = 5] = "SalesforceProcessBuilder";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceWorkflowRule"] = 6] = "SalesforceWorkflowRule";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceValidationRule"] = 7] = "SalesforceValidationRule";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceApexClass"] = 8] = "SalesforceApexClass";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceReport"] = 9] = "SalesforceReport";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceApexTrigger"] = 13] = "SalesforceApexTrigger";
    SonarObjectTypeId[SonarObjectTypeId["PardotList"] = 14] = "PardotList";
    SonarObjectTypeId[SonarObjectTypeId["PardotProfile"] = 15] = "PardotProfile";
    SonarObjectTypeId[SonarObjectTypeId["PardotForm"] = 16] = "PardotForm";
    SonarObjectTypeId[SonarObjectTypeId["PardotLandingPage"] = 17] = "PardotLandingPage";
    SonarObjectTypeId[SonarObjectTypeId["PardotEmailTemplate"] = 18] = "PardotEmailTemplate";
    SonarObjectTypeId[SonarObjectTypeId["PardotEntity"] = 19] = "PardotEntity";
    SonarObjectTypeId[SonarObjectTypeId["PardotField"] = 20] = "PardotField";
    SonarObjectTypeId[SonarObjectTypeId["SalesforcePageLayout"] = 21] = "SalesforcePageLayout";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceProfile"] = 22] = "SalesforceProfile";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceEmailTemplate"] = 23] = "SalesforceEmailTemplate";
    SonarObjectTypeId[SonarObjectTypeId["PardotAutomation"] = 24] = "PardotAutomation";
    SonarObjectTypeId[SonarObjectTypeId["PardotPageAction"] = 25] = "PardotPageAction";
    SonarObjectTypeId[SonarObjectTypeId["PardotEmail"] = 26] = "PardotEmail";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceFieldUpdate"] = 27] = "SalesforceFieldUpdate";
    SonarObjectTypeId[SonarObjectTypeId["SalesforceEmailAlert"] = 28] = "SalesforceEmailAlert";
})(SonarObjectTypeId || (exports.SonarObjectTypeId = SonarObjectTypeId = {}));
//# sourceMappingURL=SonarObjectType.js.map